import { JobEstimationDetail, IQACustomDetails } from "../modals/JobEstimationDetail";
import { NoteResponse, NotesSuggestion } from "../modals/NotesSuggestion";
import { AddNotesRequest } from "../modals/AddNotesRequest";
import { CommonMethodService } from "./CommonMethodService";
import { ImagesListEntity, IbsResponse, Feedback, EstimatePlanningJob } from "../CommonProps";
import { IInspectionAppointmentPayload, ICheckAppointment, Appointment, TimeSlots } from "../modals/Appointment";
import moment from "moment";
import { ICompassReferencePayload, ICompassReferenceResponse } from "../modals/Interface";
import { RescheduleVehicleBooking } from "../modals/RescheduleVehicleBooking";
import { LoanAssign } from "../modals/LoanAssign";
import { LoanCarBooking } from "../modals/LoanCarBooking";
import APIService, { allowedEmails } from "./APIService";
import { TaskPayload } from "../modals/TaskPayload";
import { IUploadObject } from "../UploadPhotos/UploadPhotos";

export const apiIbsAdBaseUrl = "https://ibsapi.flowautobody.com/";
// export const apiIbsAdBaseUrl = "http://127.0.0.1:3331/";

export interface IResponse {
  IsSuccess: boolean;
}
export class IBSAdonisService {
  private commonMethodService = new CommonMethodService();
  private apiService = new APIService();
  sendRequest(url: string, method: string, data?: any, token?: string) {
    let requestOptions: any = {
      method: method,
      headers: {
        "Content-Type": "application/json",
      },
    };
    const currentUserToken = this.commonMethodService.getDataFromStorage("currentUser");
    if (currentUserToken || token) {
      requestOptions["headers"] = {
        ...requestOptions["headers"],
        Authorization: `Bearer ${token ? token : currentUserToken.auth.token}`,
      };
    }
    if (data) {
      requestOptions["body"] = JSON.stringify(data);
    }
    return fetch(url, requestOptions);
  }

  public getJobEstimateDetailsById(id: string, token?: string): Promise<JobEstimationDetail> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "GetJobEstimateDetailsByIdWithUser/" + id, "GET", null, token)
        .then(async (res) => {
          if (res.ok) {
            const result: any = await res?.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public getEstimateDetailsById(estimateId: string, token?: string) {
    return this.sendRequest(apiIbsAdBaseUrl + "GetJobEstimateDetailsById/" + estimateId, "GET", null, token);
  }

  public getEstimateDetailsByIdForLogin(estimateId: string, token?: string) {
    return this.sendRequest(apiIbsAdBaseUrl + "GetJobEstimateDetailsByIdForLogin/" + estimateId, "GET", null, token);
  }

  public getInspectionsForDates(dateRange: { start: string; end: string }): Promise<Appointment[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `GetInspectionsForDates/${dateRange.start}/${dateRange.end}`, "GET")

        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public getBookSlots(dateRange: { start: string; end: string }): Promise<Appointment[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `GetBookSlots/?from=${dateRange.start}&to=${dateRange.end}`, "GET")
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public getAllUsers(): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `AllUsers`, "GET")
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public searchJobEstimate(query: string): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `SearchJobEstimate/${query}`, "GET")
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public searchEstimate(query: string): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `SearchEstimates/${query}`, "GET")
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }

  public getPublicHoliday(dateRange: { start: string; end: string }): Promise<any[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `GetPublicHoliday/?from=${dateRange.start}&to=${dateRange.end}`, "POST")
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public getInspectionTimeSlots(): Promise<TimeSlots[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `GetInspectionTimeSlots`, "GET")
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public updateAdminChecklist(estimateId: string, adminChecklist: string[]): Promise<any> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "updateAdminChecklist/" + estimateId, "PUT", { adminChecklist: adminChecklist })
        .then(async (res) => {
          if (res.ok) {
            const result: any = await res?.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public getJobEstimateDetailsByIds(ids: string[]): Promise<JobEstimationDetail[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "GetJobEstimateDetailsByIds", "POST", ids)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public getEstimatePlanning(id: string): Promise<EstimatePlanningJob> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `EstimatePlanningById/${id}`, "GET")
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public archiveImagesByEstimationIds(listId: string, imageIds: string[]) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "ArchiveImagesByIds", "POST", {
        listId: listId,
        imageIds: imageIds,
      })
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public getUserImageBase64(ids: string[]) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "GetEstimationImagesByEstimationIds", "POST", ids).then(async (res) => {
        if (res.ok) {
          const result = await res.json();
          resolve(result);
        } else {
          reject(res);
        }
      });
    });
  }

  public getImagesByEstimationId(id: string): Promise<ImagesListEntity[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "GetImagesByEstimationId", "POST", {
        id: id,
      }).then(async (res) => {
        if (res.ok) {
          const result = await res.json();
          resolve(result);
        } else {
          reject(res);
        }
      });
    });
  }

  getEstimatePDFUrl(estimateId: string) {
    return apiIbsAdBaseUrl + "GenerateEstimatePdf/" + estimateId + "/" + 0;
  }

  sendIssueJobRequest(issueJob: any, token?: string) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "IssueJob", "POST", issueJob, token)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  sendSMS(smsDetails: any) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "SendSMS", "POST", smsDetails)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }

  redeemEstimate(currEstimateId: string, currEstimatePrimaryDetailsId: string, redeemEstimateId: string, redeemEstimatePrimaryDetailsId: string) {
    let body = {
      SourceEstimateId: currEstimateId,
      SourcePrimatyDetailsId: currEstimatePrimaryDetailsId,
      ImportEstimateId: redeemEstimateId,
      ImportPrimaryDetailsId: redeemEstimatePrimaryDetailsId,
    };
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "RedeemEstimate", "POST", body)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }

  addEstimateFeedback(obj: Feedback) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "sharepoint/AddEstimateFeedback", "POST", obj)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }

  addCompleteFeedback(obj: Feedback) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "sharepoint/AddCompleteFeedback", "POST", obj)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }

  async sendTeamsNotification(data: {
    message: string;
    email: string;
    note?: {
      message: string;
      estimateId: string;
      title: string;
      estimateNumber?: number;
    };
    estimateDetails?: JobEstimationDetail;
  }) {
    if (data.note) {
      const noteResponse: NoteResponse = (await this.addNotes({
        estimateId: data.note.estimateId,
        message: `${data.note.estimateNumber || data?.estimateDetails?.estimateNumber
          } - ${data.note.message}`,
      })) as NoteResponse;
      if (
        !!noteResponse?.success &&
        noteResponse?.noteId &&
        data.estimateDetails
      ) {
        let arrayOfCheckListItems = [];
        let array = [
          "Job issue",
          "Order parts",
          "Complete key tile",
          "Print job sheet",
        ];
        for (let value of array) {
          arrayOfCheckListItems.push({
            caption: value,
            isChecked: false,
            id: "",
            isDeleted: false,
            isRenamed: false,
          });
        }
        const taskObj: TaskPayload = {
          Title: `${data.estimateDetails.estimateNumber} - ${data.note.title}`,
          assignments: [
            {
              id: data.estimateDetails.estimateId,
              userName: data.estimateDetails.estimateNumber.toString(),
              type: "Estimate",
              lastStarted: new Date(),
              isDeleted: false,
            },
            {
              id: noteResponse.noteId,
              userName: `${data.estimateDetails.estimateNumber}_note`,
              type: "EstimateNote",
              lastStarted: new Date().toISOString(),
              isDeleted: true,
            },
            {
              id: "6e69bb43-fb35-4f01-8fd3-505b4cb861e7",
              userName: "Michel Conlon",
              type: "User",
              lastStarted: new Date().toISOString(),
              isDeleted: false,
            },
          ],
          AssignDate: new Date(),
          taskItemRecurrence: null,
          additionalNote: data.note.message,
          checklistItems: arrayOfCheckListItems,
          expectedDuration: "00:15:00",
        };

        if (data.estimateDetails.estimatorId) {
          taskObj.assignments?.push({
            id: data.estimateDetails.estimatorId,
            userName: data.estimateDetails.estimatorName,
            type: "User",
            lastStarted: new Date(),
            isDeleted: false,
          });
        }
        await this.addTask("79604011-937f-44b1-95e5-404f3a5be4c8", taskObj)
      }
    }
    
    const origin = window.location.origin;
    // Block if the origin is incorrect or if the email is not allowed
    if (origin !== process.env.REACT_APP_PRODUCTION_ORIGIN) {
      console.log(`Request blocked due to disallowed origin: ${origin}`);
      return;
    }

    if (allowedEmails.includes(data.email)) {
      console.log(`Request blocked due to disallowed email: ${data.email}`);
      return;
    }

    return await this.apiService.sendRequestApiNotification(
      "notifications",
      "POST",
      data.message
    );
  }

  addTask(taskListId: string, taskObj: any) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `AddTask/TaskList/${taskListId}`, "POST", taskObj)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }

  rescheduleBooking(estimateId: string, bookingObj: RescheduleVehicleBooking) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `RescheduleVehicleBooking/${estimateId}`, "POST", bookingObj)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }

  getEmailTemplates(estimateId: string): Promise<NotesSuggestion[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `EmailMessageTemplates/${estimateId}`, "GET")

        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }

  getTasksForUser(taskListId: string): Promise<IbsResponse> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `GetTasksForUser/${taskListId}`, "GET")
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }

  textMessageSuggestions(estimateId: string): Promise<NotesSuggestion[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `TextMessageSuggestions/${estimateId}`, "GET")
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }

  sendEmailWithTemplate(emailDetails: any) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "SendEmail", "POST", emailDetails)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }

  addNotes(note: AddNotesRequest) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "AddNotes", "POST", note)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  createLoanCarBookings(body: LoanCarBooking) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "CreateLoanCarBooking", "POST", body)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }

  getLoanCars() {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "GetLoanCar/486de059-b439-4796-9a20-23512e4d33cd", "POST", {})
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  getLoanCarsBookings(startDate: string, endDate: string): Promise<LoanAssign[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `GetLoanCarViewSlider?startDate=${startDate}&endDate=${endDate}`, "POST", {})
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  deleteTask(taskId: string): Promise<IbsResponse> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + `DeleteTask/${taskId}`, "POST", {})
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  getEstimateNotesDetails(estimateId: string) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "EstimateNotesDetails/" + estimateId, "GET")
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  getNoteSuggestion(): Promise<NotesSuggestion[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "NoteSuggestion/", "GET")
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public updateWorkType(estimateId: string, workType: string) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "UpdateWorkType/" + estimateId + "/" + workType, "PUT", null)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public booking(data: any) {
    return this.sendRequest(apiIbsAdBaseUrl + "BookService", "POST", data);
  }

  public async updateQCAssessmentDetail(payload: any) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "qaProcessValues/customerAssessmentValues", "PUT", payload)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public async getAllRefrencesList() {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "getAllReferenceList", "GET")
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
    // return this.http.get(this.apiIbsAdBaseUrl + `getAllReferenceList`, {
    //   headers: this.apiService.getDefaultHeaders(this.currentUser.auth.token),
    // });
  }

  public getCustomQADetails(estimateId: string, token?: string): Promise<IQACustomDetails[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "qaCustomFields/" + estimateId, "GET", null, token)
        .then(async (res) => {
          if (res.ok) {
            const result: any = await res?.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public checkInspectionSlot(body: { fromDate: string; toDate: string; estimatorId?: string }): Promise<ICheckAppointment[]> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "CheckInspectionSlot", "POST", body)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public createInspectionAppointment(payload: IInspectionAppointmentPayload): Promise<IResponse> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "CreateAppointmentForInspection", "POST", payload)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public updateInspectionAppointment(payload: IInspectionAppointmentPayload): Promise<IResponse> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "UpdateAppointmentForInspection", "POST", payload)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  async fetchInspectionData(estimateId: string) {
    const fromDate = moment().startOf("day");
    const toDate = moment().add(3, "months").startOf("day");
    const formattedFromDate = fromDate.format("YYYY-MM-DDTHH:mm:ss.SSSSSSS");
    const formattedToDate = toDate.format("YYYY-MM-DDTHH:mm:ss.SSSSSSS");
    const datesResponse: Appointment[] = await this.getInspectionsForDates({
      start: formattedFromDate,
      end: formattedToDate,
    });
    const filteredRecord = datesResponse?.filter((record: any) =>
      record.assignments.some((assignment: any) => assignment.assignedToType === "Estimate" && assignment.assignedToName === estimateId)
    );

    if (filteredRecord.length) {
      return filteredRecord[0];
    }
    return null;
  }

  public async bookInCompassReference(payload: ICompassReferencePayload) {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "CompassReference", "POST", payload)
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  public fetchCompassReference(estimateId: string): Promise<ICompassReferenceResponse | null> {
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "GetCompassReference/" + estimateId, "GET", null)
        .then(async (res) => {
          if (res.ok) {
            try {
              const result: any = await res?.json();
              resolve(result);
            } catch (err) {
              console.error('Error parsing JSON:', err);
              resolve(null);
            }
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          console.log(ex);
          reject(ex);
        });
    });
  }

  addImagesBase64(images: IUploadObject, category: string) {
    return this.sendRequest(
      apiIbsAdBaseUrl + "AddImagesBase64/" + category,
      "POST",
      {
        ...images,
      }
    );
  }

  getHighResolutionImageUrl(imageId: string) {
    return apiIbsAdBaseUrl + "Images/" + imageId;
  }

  acceptEstimate(estimateId: string, obj: any) {
    return this.sendRequest(
      apiIbsAdBaseUrl + "AuthoriseEstimate/" + estimateId,
      "POST",
      {
        ...obj,
      }
    );
  }

  async sendEmail(
    emailBody: string,
    subject: string,
    estimateId: string,
    estimateNumber: string,
    toAddress?: string,
  ) {
    const body = {
      fromName: "Flow Autobody",
      subject,
      attachments: [],
      body: emailBody,
      bodyIsHtml: true,
      to: [toAddress ?? "hello@flowautobody.com.au"], // Ensures 'to' is never undefined
      cc: ["hello@flowautobody.com.au"],
      assignedToId: estimateId,
      jobNumber: estimateNumber,
    };

    return this.sendEmailWithTemplate(body);
  }

  insertBulkActionLogs(actions: { estimateId: string; actionType: string; automated?: boolean; is_manual_automation?: boolean }[]) {
    const processedActions = actions.map((action) => ({
      ...action,
      automated: action.automated ?? true,
      is_manual_automation: action.is_manual_automation ?? false,
    }));
    return new Promise((resolve, reject) => {
      this.sendRequest(apiIbsAdBaseUrl + "actionLogs", "POST", { actions: processedActions })
        .then(async (res) => {
          if (res.ok) {
            const result = await res.json();
            resolve(result);
          } else {
            reject(res);
          }
        })
        .catch((ex) => {
          reject(ex);
        });
    });
  }


  declineEstimate(estimateId: string) {
    let obj = {
      EstimateId: estimateId,
      ReasonForCancel: "Decline Estimate",
    };
    return this.sendRequest(
      `${apiIbsAdBaseUrl}CancelEstimate/`,
      "POST",
      obj
    );
  }
}
